<template>
  <a-card :bordered="false" class="m-t-10">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      创建调仓单
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="调仓单" name='warehousing_sn'>{{form.transfer_warehousing_sn}}</a-form-item>
      <a-form-item label="调仓仓库" name='transfer_to_warehouse_id'>
        <a-select v-model:value="form.transfer_to_warehouse_id" style='width: 40%;' placeholder='请选择仓库' @change='selectChange' :disabled="$route.query.type == 'edit' || isDisabled">
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="库位" name='transfer_to_warehouse_position_id'>
        <a-select v-model:value="form.transfer_to_warehouse_position_id" style='width: 40%;' placeholder='请选择库位' :disabled="!form.transfer_to_warehouse_id || $route.query.type == 'edit' || isDisabled">
           <a-select-option :value="0">无</a-select-option>
          <a-select-option v-for='item in warehouseChild' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
        <a-button class='m-l-10' @click='form.transfer_to_warehouse_position_id = null' :disabled="!form.transfer_to_warehouse_id || $route.query.type == 'edit' || isDisabled">清空</a-button>
      </a-form-item>
      <a-form-item label="商品" name='goodList'>
        <a-button type="primary" @click='showGood = true'>
          <PlusOutlined />添加商品
        </a-button>
        <a-table class='m-t-20' :pagination='false' :loading='loading' bordered rowKey='product_sn' :columns='columns' :data-source='goodList'>
          <template v-slot:gift_name="{ record }">
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
              </template>
              <template #description>
                <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
              </template>
            </a-card-meta>
          </template>
          <template v-slot:num="{ record }">
            <a-input-number style='width: 100%;' v-model:value="record.num" :precision='0' :min='1' placeholder='请输入数量' />
            <p v-if='record.fail' style='color:#ff4d4f'>请输入调仓数量！</p>
          </template>
          <template v-slot:action="{ index }">
            <a-button type="link" @click='delGood(index)'>删除</a-button>
          </template>
        </a-table>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 10, offset: 3}">
        <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">取消</a-button>
        <a-button class="width-100 m-r-20" block @click="onSubmit">保存</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-modal :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1200' :footer="null" destroyOnClose>
    <warehousingGoods v-on:select="goodSelect" :selectList='goodList' :checkout="true"></warehousingGoods>
  </a-modal>
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { LeftOutlined } from "@ant-design/icons-vue";
import { message, Modal } from "ant-design-vue";
import { iscode } from "@/utils/app";
import warehousingGoods from "../../components/warehousingGoods.vue";
import {
  getWarehouseList,
  getTransferWarehousingSn,
  createTransferWarehousingOrder,
} from "@/api/antiFleeing";
import store from "@/store";
let defForm = {
  transfer_warehousing_sn: "",
  transfer_to_warehouse_id: null,
  transfer_to_warehouse_position_id: 0,
  remark:"",
  product:[]
};
const columns = [
  {
    title: "商品编码",
    dataIndex: "product_sn",
    key: "product_sn",
  },
  {
    title: "商品信息",
    dataIndex: "gift_name",
    key: "gift_name",
    slots: { customRender: "gift_name" },
  },
  {
    title: "规格",
    dataIndex: "product_sku_name",
    key: "product_sku_name",
    customRender: ({ record }) => {
      return record.product_sku_name ? record.product_sku_name : "单规格";
    },
  },
  {
    title: "调仓数量",
    dataIndex: "num",
    key: "num",
    slots: { customRender: "num" },
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  components: { LeftOutlined, warehousingGoods },
  setup() {
    const ruleForm = ref();
    const form = ref({ ...defForm });
    const state = reactive({
      goodList: [],
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      warehouseList: [],
      warehouseChild: [],
      showGood: false,
      showBatch: false,
      showResult: false,
      scanCodeNum: 0, //扫码数量
      successNum: 0, // 成功数量
      successGoodsNum: 0, //成功商品数量
      resultCode: "", //扫码结果code
      resultMsg: "", // 扫码结果提示语
      isDisabled: false, // 扫码成功禁用一些选项
      rules: {
        transfer_warehousing_sn: [{ required: true, message: "调仓单号不能为空" }],
        transfer_to_warehouse_id: [
          { required: true, message: "请选择调仓仓库", type: "number" },
        ],
      },
    });
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $router = inject("$router");
    // 获取仓库
    const getWarehouse = async () => {
      let res = await getWarehouseList().then((res) => res.data);
      if (iscode(res)) {
        state.warehouseList = res.data;
        // 默认选择默认仓库
        form.value.transfer_to_warehouse_id = res.data[0].id;
         state.warehouseChild =  res.data[0].child || [];
      } else {
        message.error(res.msg);
      }
    };
    // 生成调仓单号
    const warehousingSnGet = async () => {
      let res = await getTransferWarehousingSn().then(res => res.data);
        if (iscode(res)) {
          form.value.transfer_warehousing_sn = res.data.transfer_warehousing_sn;
        } else {
          message.error(res.msg);
        }
    };
    //选择仓库
    const selectChange = () => {
      form.value.transfer_to_warehouse_position_id = 0;
      var item = state.warehouseList.find(
        (v) => v.id == form.value.transfer_to_warehouse_id
      );
      state.warehouseChild = item.child || [];
    };

    //选择商品
    const goodSelect = (e) => {
      state.goodList = e;
      state.showGood = false;
    };
    //删除商品
    const delGood = (index) => {
      state.goodList.splice(index, 1);
    };


    //提交
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          if(!state.goodList.length){
            return message.error("请选择商品")
          }
          var flag=false
          state.goodList.forEach(element => {
            if(!element.num){
              flag=true
            }
          })
          if(flag){
            return  message.error("请完善调仓商品数量")
          }
          Modal.confirm({
            centered: true,
            title: "确认生成调仓单",
            content: "保存后商品信息将无法修改",
            onOk: async () => {
              var product=state.goodList.map(v=>v.product_id+'_'+(v.product_sku_sn||0) +'_'+v.num)
              const hide = message.loading("正在加载中...", 0);
              let res = await createTransferWarehousingOrder({ ...form.value,product })
                .then((res) => res.data)
                .catch((error) => error);
              if (iscode(res, true)) {
                $router.go(-1);
              } else {
                message.error(res.msg);
              }
              setTimeout(hide);
            },
          });
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    onMounted(() => {
      getWarehouse();
      warehousingSnGet();
    });
    return {
      form,
      ruleForm,
      ...toRefs(state),
      onSubmit,
      selectChange,
      goodSelect,
      delGood,
      columns,
      info: store.state.user.info,
    };
  },
};
</script>